import React from 'react';
import { Card } from './Card';

interface LoadingCardProps {
  className?: string;
  showHeader?: boolean;
  showContent?: boolean;
  showFooter?: boolean;
  lines?: number;
}

export const LoadingCard: React.FC<LoadingCardProps> = ({
  className = '',
  showHeader = true,
  showContent = true,
  showFooter = false,
  lines = 3
}) => {
  return (
    <Card className={`animate-pulse ${className}`}>
      {showHeader && (
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-gray-300 dark:bg-gray-600 rounded-full" />
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-3/4" />
            <div className="h-3 bg-gray-300 dark:bg-gray-600 rounded w-1/2" />
          </div>
        </div>
      )}
      
      {showContent && (
        <div className="space-y-3">
          {Array.from({ length: lines }, (_, index) => (
            <div
              key={index}
              className={`
                h-4 bg-gray-300 dark:bg-gray-600 rounded
                ${index === lines - 1 ? 'w-2/3' : 'w-full'}
              `}
            />
          ))}
        </div>
      )}
      
      {showFooter && (
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
          <div className="h-3 bg-gray-300 dark:bg-gray-600 rounded w-1/4" />
          <div className="h-8 bg-gray-300 dark:bg-gray-600 rounded w-20" />
        </div>
      )}
      
      <span className="sr-only">Loading...</span>
    </Card>
  );
};